module.exports = __webpack_public_path__ + "static/media/logo-5star.85b29d81.svg";